<template>
  <div class="drug">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="名称" label-width="40px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="id"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="name"
            label="名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="编号">
        </el-table-column>
        <el-table-column
            prop="address"
            label="地址">
        </el-table-column>
        <el-table-column
            prop="corporate"
            label="法人">
        </el-table-column>
        <el-table-column
            prop="phone"
            label="电话">
        </el-table-column>
        <el-table-column
            prop="email"
            label="邮箱">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>
            <!--            <el-button type="text" size="medium" @click="lockClick(scope.row.id)">锁定</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px"  class="demo-ruleForm">
        <el-form-item label="药房名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="药房编码" prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="医疗机构" required>
          <DicInput style="width: 100%" :initName="ruleForm.name" @fieldId="ruleFormFieldId($event,'medicalInstitutionId')" :url="'api/MedicalInstitution/all'"></DicInput>
        </el-form-item>
        <el-form-item label="地区" required>
          <DicInput style="width: 100%" :initName="ruleForm.name" @fieldId="ruleFormFieldId($event,'areaId')" :url="'api/Area/all'"></DicInput>
        </el-form-item>
        <el-form-item label="药房地址">
          <el-input v-model="ruleForm.address" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码">
          <el-input v-model="ruleForm.corporateIdCard" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="经度">
          <el-input v-model="ruleForm.longitude" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="纬度">
          <el-input v-model="ruleForm.latitude" placeholder="请输入"></el-input>
        </el-form-item>

        <!--        <el-form-item label="当前版本">-->
        <!--          <el-radio-group v-model="ruleForm.currentVersion">-->
        <!--            <el-radio-button :label="true">是</el-radio-button>-->
        <!--            <el-radio-button :label="false">否</el-radio-button>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from "@/components/DicInput";
export default {
  name: "drug",
  data() {
    return {
      tableData: [],
      searchForm: {
        name: '',
        code: '',
      },
      modelTitle: '新增药房',
      dialogVisible: true,
      ruleForm: {
        name: '',
        code: '',
      },
      MedicalInstitutionOptions:[],
      areaOptions:[],
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        medicalInstitutionId: [
          {required: true, message: '请选择医疗机构', trigger: 'change'},
        ],
        area: [
          {required: true, message: '请选择地区', trigger: 'change'},
        ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      userJson:{},
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  created() {
    this.userJson = window.utils.storage.getter('userJson')
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
        parentCode: ''
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    ruleFormFieldId(item,name){ // 字典
      if(item.id){
        if(name==='medicalInstitutionId'){
          this.ruleForm.medicalInstitutionId=Number(item.id)
        }else {
          this.ruleForm.area=item.name
          this.ruleForm.areaCode=item.code
          this.ruleForm.areaId=(item.id)
        }
      }else {
        this.ruleForm[name]=''
      }
    },
    areaFun(e,i){
      console.log(e)
    },
    addItem() {
      this.modelTitle = '新增药房'
      this.ruleForm = {
        name:'',
      }
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑药房'
      this.areaId = row.id
      this.ruleForm = {
        ...row
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          if (this.modelTitle === '编辑药房') {
            let data = {
              ...this.ruleForm,
              status:'0'
            }
            this.axios
                .put("api/Operator?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          } else {
            let data = {
              ...this.ruleForm,
              status:'0',
              operatorId:this.userJson.operatorId,
              operatorCode:this.userJson.operatorCode
            }
            this.axios
                 .post("api/Pharmacy", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    deleteClick(id) {
      let data = {
        id: id
      }
      this.axios
           .delete("api/Pharmacy/GetByOperator", {params:data}).then((res) => {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
      }).finally(error=>{
        this.init()
      })
    },
    lockClick(id){
      let data = {
        id: id
      }
      this.axios
           .delete("api/Operator/Lock?id="+flag.id, {params:data}).then((res) => {
        this.$message({
          message: '锁定成功',
          type: 'success'
        });
      }).finally(error=>{
        this.init()
      })
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/Pharmacy/GetByOperator", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    },
    list(){
      this.axios
          .get("api/MedicalInstitution/all" ) .then((res) => {
        this.MedicalInstitutionOptions = res.list
        this.MedicalInstitutionOptions.forEach(item=>{
          item.value=item.id
          item.label=item.name
        })
      }),
          this.axios
              .get("api/" ) .then((res) => {
            this.areaOptions = res.list
            this.areaOptions.forEach(item=>{
              item.value=item.code
              item.label=item.name
            })
          })
    }
  },
  mounted() {
    //
    this.init()
    // this.list()
  }
}
</script>

<style lang="scss" scoped>
.drug {

}
</style>